// simple email validation
export function isValidEmail(email) {
  var emailRegex = /\S+@\S+\.\S+/;
  return emailRegex.test(email);
}

export function capitalizeWord(string) {
  if (string?.length > 0) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}

export function aOrAn(nextWord) {
  if (nextWord?.length > 0) {
    const VOWELS = ['a', 'e', 'i', 'o', 'u'];
    return VOWELS.includes(nextWord[0].toLowerCase()) ? 'an' : 'a';
  }
  return 'a';
}
